export const CART_ACTIONS_TYPES = {
  ADD: 'ADD',
  UPDATE: 'UPDATE',
};

export const CART = 'CART';
export const NOTE = 'NOTE';
